/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllRentalPlans = (state) => values(get(state, ['rentalPlans', 'items']));

export const getAllRetailerRentalPlans = (state) => values(get(state, ['retailerRentalPlans', 'items']));

export const requestingRentalPlans = (state) => get(state, ['rentalPlans', 'requesting']);

export const requestingRetailerRentalPlans = (state) => get(state, ['retailerRentalPlans', 'requesting']);

export const errorRequestingRentalPlans = (state) => get(state, ['rentalPlans', 'error']);

export const errorRequestingRetailerRentalPlans = (state) => get(state, ['retailerRentalPlans', 'error']);